/* eslint-disable */
import React, { useState } from "react";
import JEDialog from "../AccountData/JEDialog";
import axios from "axios";
import { useEffect } from "react";
import SideBar from "../SideBar.js";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { Link } from "react-router-dom";

import useCollapse from "react-collapsed";
import {
  FaCashRegister,
  FaFileMedical,
  FaFileExcel,
  FaAngleDown,
  FaAngleUp,
  FaList,
  FaRegUser,
  FaClipboardCheck,
  FaPowerOff,
  FaRegEdit,
  FaRegTrashAlt,
} from "react-icons/fa";

const Income = () => {
  const token = localStorage.getItem("token");
  const url = process.env.REACT_APP_APP_URL;
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const scroll = {
    height: "550px",
    overflowY: "scroll",
  };
  const [isExpanded, setExpanded] = useState(false);
  const [isAccData, setAccData] = useState(false);
  const [relatedLists, setRelatedLists] = useState([]);
  const [isShow, setIsShow] = useState(false);
  const [searchList, setSearchList] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [showOri, setShowOri] = useState(true);
  const [showBranch, setShowBranch] = useState(false);
  const [branchLists, setBranchLists] = useState([]);
  const [branchFilterList, setBranchFilterList] = useState([]);
  const [showBranchFilter, setShowBranchFilter] = useState(false);
  const [JEOri, setJEOri] = useState([]);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [showDate, setShowDate] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [dateList, setDateList] = useState([]);
  const { getCollapseProps, getToggleProps } = useCollapse();

  const handleAdminChange = () => {
    setExpanded(!isExpanded);
  };

  const handleAccChange = () => {
    setAccData(!isAccData);
  };

  const [journalEntryLists, setJournalEntryLists] = useState([]);
  const [open, setOpen] = useState(false);
  const [close, setClose] = useState(false);

  const showDialog = () => setOpen(true);
  const _export = React.useRef(null);
  const excelExport = () => {
    if (_export.current !== null) {
      console.log(_export.current.props.data);
      _export.current.props.data.map(function (element, index) {
        element.date = element.date ? element.date.split("T")[0] : "";
      });
      _export.current.save();
    }
  };

  const handleDelete = (val) => {
    console.log(val, "delete id");
    const getDELETE = async () => {
      console.log("ehre==");

      const res = await api
        .delete("journal/" + val)
        .then((response) => {
          Swal.fire({
            title: "Success",
            text: "Successfully Deleted!",
            icon: "success",
            confirmButtonText: "OK",
          });

          setJournalEntryLists(
            journalEntryLists.filter((item) => item._id !== val)
          );
        })

        .catch((error) => {
          Swal.fire({
            title: "Error",
            text: error.response.data.message,
            icon: "error",
            confirmButtonText: "CANCEL",
          });
        });
    };
    getDELETE();
  };
  const handleBranch = (id) => {
    Swal.fire({
      title: "Loading ...",
      text: "Please Wait !",
      allowEscapeKey: false,
      allowOutsideClick: false,
      timer: 4000,
    }).then(
      () => { },
      (dismiss) => {
        if (dismiss === "timer") {
          console.log("closed by timer!!!!");
          Swal.fire({
            title: "Finished!",
            type: "success",
            timer: 4000,
            showConfirmButton: false,
          });
        }
      }
    );
    console.log(id, "name");
    if (id == "HO") {
      setShowBranchFilter(false);
      setShowOri(true);
      setShowSearch(false);
    } else {
      setBranchFilterList(
        JEOri.filter(
          (el) => (el.relatedBranch ? el.relatedBranch._id : "") === id
        )
      );
      console.log(
        JEOri.filter(
          (el) => (el.relatedBranch ? el.relatedBranch._id : "") === id
        ),
        "filter"
      );
      setShowBranchFilter(true);
      setShowOri(false);
      setShowSearch(false);
    }
  };
  const handleRelatedShow = (id, val) => {
    const getRelated = async () => {
      try {
        console.log(val);
        const res = await api.get("journal/related/" + val);

        console.log(res.data.data);
        setRelatedLists(res.data.data);
      } catch (err) { }
    };

    getRelated();

    if (isShow) {
      document.getElementById("toggle" + id).removeAttribute("hidden");
    } else {
      document.getElementById("toggle" + id).setAttribute("hidden", "hidden");
    }
    setIsShow(!isShow);
  };

  const handleDate = () => {
    const nDate = new Date(to);
    const endDate = nDate.setDate(nDate.getDate() + 1);

    Swal.fire({
      title: "Loading ...",
      text: "Please Wait !",
      allowEscapeKey: false,
      allowOutsideClick: false,
      timer: 4000,
    }).then(
      () => { },
      (dismiss) => {
        if (dismiss === "timer") {
          console.log("closed by timer!!!!");
          Swal.fire({
            title: "Finished!",
            type: "success",
            timer: 4000,
            showConfirmButton: false,
          });
        }
      }
    );

    setDateList(
      JEOri.filter(
        (el) =>
          (el.date ? el.date.split("T")[0] : "") >= from &&
          (el.date ? el.date.split("T")[0] : "") <= to
      )
    );
    setShowDate(true);
    setShowOri(false);
    setShowSearch(false);
    setShowBranchFilter(false);
  };
  const search = () => {
    console.log(searchVal, "name");
    Swal.fire({
      title: "Loading ...",
      text: "Please Wait !",
      allowEscapeKey: false,
      allowOutsideClick: false,
      timer: 4000,
    }).then(
      () => { },
      (dismiss) => {
        if (dismiss === "timer") {
          console.log("closed by timer!!!!");
          Swal.fire({
            title: "Finished!",
            type: "success",
            timer: 4000,
            showConfirmButton: false,
          });
        }
      }
    );

    if (searchVal) {
      setSearchList(
        journalEntryLists.filter(
          (el) =>
            (el.relatedAccounting ? el.relatedAccounting.name : "")
              .toLowerCase()
              .includes(searchVal.toLowerCase()) ||
            (el.type ? el.type : "")
              .toLowerCase()
              .includes(searchVal.toLowerCase())
        )
      );
      console.log(
        journalEntryLists.filter((el) =>
          el.relatedAccounting ? el.relatedAccounting.name : ""
        ),
        "fil"
      );
      setShowSearch(true);
      setShowOri(false);
    } else {
      setShowSearch(false);
      setShowOri(true);
    }
  };
  useEffect(() => {
    const getIncomeLists = async () => {
      try {
        Swal.fire({
          title: "Loading ...",
          text: "Please Wait !",
          allowEscapeKey: false,
          allowOutsideClick: false,
          timer: 4000,
        });

        const res = await api.get("journals?limit=50");

        // const result = res.data.list.filter((e) => e.relatedCashAccount.name == 'Cash in Hand-MMK');

        // console.log(result);
        // console.log();
        setJEOri(res.data.list);
        setJournalEntryLists(res.data.list.filter((el) => !el.relatedBranch));
        console.log(res.data.list, "JE list");
      } catch (err) {
        alert(err.message);
      }
    };
    const getBranches = async () => {
      try {
        const res = await api.get("branches");
        setBranchLists(res.data.list);
      } catch (err) {
        alert(err.message);
      }
    };
    getBranches();

    getIncomeLists();
  }, []);

  return (
    <div classNameName='App'>
      <div className='wrapper'>
        {/* <!-- Main Sidebar Container --> */}
        <SideBar />

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className='content-wrapper'>
          {/* <!-- Content Header (Page header) --> */}
          <div className='content-header'>
            <div className='container-fluid'>
              <div className='row mb-2'>
                <div className='col-sm-12'>
                  <ol className='breadcrumb'>
                    <li className='breadcrumb-item active'>
                      Journal Entry List
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className='content'>
            <div className='container-fluid'>
              <div className='row'>
                <div className='col-md-6'>
                  <div className='row'>
                    <div className='form-group col-md-3'>
                      <label>From</label>
                      <input
                        type='date'
                        name='from'
                        id='from'
                        className='form-control'
                        onChange={(e) => setFrom(e.target.value)}
                      />
                    </div>
                    <div className='form-group col-md-3'>
                      <label>To</label>
                      <input
                        type='date'
                        name='to'
                        id='to'
                        className='form-control'
                        onChange={(e) => setTo(e.target.value)}
                      />
                    </div>
                    <div
                      className='form-group col-md-2'
                      style={{ marginTop: "2.5em" }}
                    >
                      <button
                        className='btn btn-primary form-control'
                        onClick={handleDate}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='row'>
                    <div
                      className='col-5 form-group'
                      style={{ marginTop: "35px" }}
                    >
                      <input
                        type='search'
                        className='form-control rounded'
                        id='search_code'
                        placeholder='Search'
                        onChange={(e) => setSearchVal(e.target.value)}
                      />
                    </div>
                    <div className='col-2'>
                      <button
                        type='button'
                        className='btn btn-outline-primary'
                        style={{ marginTop: "2.6em" }}
                        onClick={search}
                      >
                        Search
                      </button>
                    </div>
                    <div className='col-md-4' style={{ marginTop: "2.9em" }}>
                      <div className='form-group'>
                        <select
                          name='currency'
                          id=''
                          className='form-control '
                          // onchange='convert(this.value)'
                          // placeholder='Filter By Branches'
                          onChange={(e) => handleBranch(e.target.value)}
                        >
                          <option hidden>Filter By Branches</option>
                          <option value='HO'>HO</option>

                          {branchLists.map((option) => (
                            <option value={option._id}>{option.name}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-12'>
                  <div className='card'>
                    <div className='card-header'>
                      <div className='row justify-content-between'>
                        <label className=''>
                          {/* Income Transaction List */}
                          <span className='float-right'>
                            <button
                              type='button'
                              className='btn btn-sm btn-primary'
                              onClick={showDialog}
                            >
                              <i className='fas fa-plus'></i> Add
                            </button>
                            &nbsp;
                            {/* <a href="/income_type" className="btn btn-primary">
                            Income Type
                          </a> */}
                            <button
                              type='button'
                              className='btn btn-sm btn-success'
                              onClick={excelExport}
                            >
                              <FaFileExcel />
                              &nbsp; Export
                            </button>
                          </span>
                        </label>
                      </div>
                      <div className='row' id='trial_balance'></div>
                    </div>

                    <div className='card-body'>
                      {/* Export data in Excel */}
                      <ExcelExport data={JEOri} ref={_export}>
                        <ExcelExportColumn
                          field=''
                          title='No'
                          locked={true}
                          width={30}
                        />
                        <ExcelExportColumn
                          field='date'
                          title='Date'
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={200}
                        />

                        {/* <ExcelExportColumn
                          field='relatedBankAccount.name'
                          title='Bank Account'
                          headerCellOptions={{
                            textAlign: 'center'
                          }}
                          width={250}
                        /> */}

                        <ExcelExportColumn
                          field='relatedAccounting.name'
                          title='Account'
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field='relatedBranch'
                          title='Branch'
                          width={150}
                        />
                        <ExcelExportColumn
                          field='type'
                          title='Type'
                          width={150}
                        />

                        <ExcelExportColumn
                          field='remark'
                          title='Remark'
                          width={150}
                        />
                      </ExcelExport>
                      {/* Export Data in Excel end */}
                      <div className='row'>
                        <div className='col-md-12'>
                          <div
                            className='table-responsive text-black'
                            id='slimtest2'
                            style={scroll}
                          >
                            <table
                              className='table table-hover'
                              id='filter_date'
                            >
                              <thead className='sticky-top bg-light'>
                                <tr>
                                  <th>#</th>
                                  <th>Date</th>
                                  <th>Account</th>
                                  <th>Credit / Debit</th>
                                  <th>Branch</th>
                                  <th>Amount</th>

                                  <th>Remark</th>
                                  <th className='text-center'>Action</th>
                                </tr>
                              </thead>

                              {showSearch &&
                                searchList
                                  .slice(0)
                                  .reverse()
                                  .map((journalEntry, i) => (
                                    <tbody className=''>
                                      <tr>
                                        <td>{++i}</td>
                                        <td>
                                          {journalEntry.date
                                            ? journalEntry.date.split("T")[0]
                                            : ""}
                                        </td>
                                        <td>
                                          {journalEntry.relatedAccounting
                                            ? journalEntry.relatedAccounting
                                              .name
                                            : ""}
                                        </td>
                                        <td>
                                          {journalEntry.type}

                                          {/* {
                                        journalEntry.relatedCashAccount ? journalEntry
                                          .relatedCashAccount.name:''
                                      } */}
                                        </td>
                                        <td>
                                          {journalEntry.relatedBranch
                                            ? journalEntry.relatedBranch.name
                                            : "HO"}
                                        </td>

                                        <td>{journalEntry.amount}</td>

                                        <td>{journalEntry.remark}</td>

                                        <td className='text-center'>
                                          <Link
                                            to={
                                              "/je-update/" + journalEntry._id
                                            }
                                            className='btn btn-sm btn-warning'
                                          // onClick={e =>
                                          //   handleUpdate(journalEntry._id)
                                          // }
                                          >
                                            <FaRegEdit />
                                          </Link>
                                          &nbsp;
                                          <button
                                            className='btn btn-sm btn-danger'
                                            onClick={(e) =>
                                              handleDelete(journalEntry._id)
                                            }
                                          >
                                            <FaRegTrashAlt />
                                          </button>
                                        </td>
                                      </tr>

                                      <tr
                                        className='bg-light'
                                        id={"toggle" + journalEntry._id}
                                        hidden
                                      >
                                        <td colspan='12'>
                                          <div>
                                            <div class='row'>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  No
                                                </label>
                                              </div>
                                              <div class='col-md-3'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Account
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Type
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Date
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Amount
                                                </label>
                                              </div>
                                            </div>

                                            {relatedLists
                                              ? relatedLists.map(
                                                (reList, i) => (
                                                  <div class='row'>
                                                    <div class='col-md-2'>
                                                      <div
                                                        style={{
                                                          fontSize: "15px",
                                                        }}
                                                      >
                                                        {++i}
                                                      </div>
                                                    </div>
                                                    <div class='col-md-3'>
                                                      <div
                                                        style={{
                                                          fontSize: "15px",
                                                        }}
                                                      >
                                                        {
                                                          reList
                                                            .relatedAccounting
                                                            .name
                                                        }
                                                      </div>
                                                    </div>
                                                    <div class='col-md-2'>
                                                      {reList.type}
                                                    </div>
                                                    <div class='col-md-2'>
                                                      <div
                                                        style={{
                                                          fontSize: "15px",
                                                        }}
                                                      >
                                                        {
                                                          reList.date.split(
                                                            "T"
                                                          )[0]
                                                        }
                                                      </div>
                                                    </div>
                                                    <div class='col-md-2'>
                                                      <div
                                                        style={{
                                                          fontSize: "15px",
                                                        }}
                                                      >
                                                        {reList.amount}
                                                      </div>
                                                    </div>
                                                  </div>
                                                )
                                              )
                                              : ""}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  ))}
                              {showDate &&
                                dateList
                                  .slice(0)
                                  .reverse()
                                  .map((journalEntry, i) => (
                                    <tbody className=''>
                                      <tr>
                                        <td>{++i}</td>
                                        <td>
                                          {journalEntry.date
                                            ? journalEntry.date.split("T")[0]
                                            : ""}
                                        </td>
                                        <td>
                                          {journalEntry.relatedAccounting
                                            ? journalEntry.relatedAccounting
                                              .name
                                            : ""}
                                        </td>
                                        <td>
                                          {journalEntry.type}

                                          {/* {
                                        journalEntry.relatedCashAccount ? journalEntry
                                          .relatedCashAccount.name:''
                                      } */}
                                        </td>
                                        <td>
                                          {journalEntry.relatedBranch
                                            ? journalEntry.relatedBranch.name
                                            : "HO"}
                                        </td>

                                        <td>{journalEntry.amount}</td>

                                        <td>{journalEntry.remark}</td>

                                        <td className='text-center'>
                                          <Link
                                            to={
                                              "/je-update/" + journalEntry._id
                                            }
                                            className='btn btn-sm btn-warning'
                                          // onClick={e =>
                                          //   handleUpdate(journalEntry._id)
                                          // }
                                          >
                                            <FaRegEdit />
                                          </Link>
                                          &nbsp;
                                          <button
                                            className='btn btn-sm btn-danger'
                                            onClick={(e) =>
                                              handleDelete(journalEntry._id)
                                            }
                                          >
                                            <FaRegTrashAlt />
                                          </button>
                                        </td>
                                      </tr>

                                      <tr
                                        className='bg-light'
                                        id={"toggle" + journalEntry._id}
                                        hidden
                                      >
                                        <td colspan='12'>
                                          <div>
                                            <div class='row'>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  No
                                                </label>
                                              </div>
                                              <div class='col-md-3'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Account
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Type
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Date
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Amount
                                                </label>
                                              </div>
                                            </div>

                                            {relatedLists
                                              ? relatedLists.map(
                                                (reList, i) => (
                                                  <div class='row'>
                                                    <div class='col-md-2'>
                                                      <div
                                                        style={{
                                                          fontSize: "15px",
                                                        }}
                                                      >
                                                        {++i}
                                                      </div>
                                                    </div>
                                                    <div class='col-md-3'>
                                                      <div
                                                        style={{
                                                          fontSize: "15px",
                                                        }}
                                                      >
                                                        {
                                                          reList
                                                            .relatedAccounting
                                                            .name
                                                        }
                                                      </div>
                                                    </div>
                                                    <div class='col-md-2'>
                                                      {reList.type}
                                                    </div>
                                                    <div class='col-md-2'>
                                                      <div
                                                        style={{
                                                          fontSize: "15px",
                                                        }}
                                                      >
                                                        {
                                                          reList.date.split(
                                                            "T"
                                                          )[0]
                                                        }
                                                      </div>
                                                    </div>
                                                    <div class='col-md-2'>
                                                      <div
                                                        style={{
                                                          fontSize: "15px",
                                                        }}
                                                      >
                                                        {reList.amount}
                                                      </div>
                                                    </div>
                                                  </div>
                                                )
                                              )
                                              : ""}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  ))}

                              {showBranchFilter &&
                                branchFilterList
                                  .slice(0)
                                  .reverse()
                                  .map((journalEntry, i) => (
                                    <tbody className=''>
                                      <tr>
                                        <td>{++i}</td>
                                        <td>
                                          {journalEntry.date
                                            ? journalEntry.date.split("T")[0]
                                            : ""}
                                        </td>
                                        <td>
                                          {journalEntry.relatedAccounting
                                            ? journalEntry.relatedAccounting
                                              .name
                                            : ""}
                                        </td>
                                        <td>{journalEntry.type}</td>
                                        <td>
                                          {journalEntry.relatedBranch
                                            ? journalEntry.relatedBranch.name
                                            : "HO"}
                                        </td>

                                        <td>{journalEntry.amount}</td>

                                        <td>{journalEntry.remark}</td>

                                        <td className='text-center'>
                                          <Link
                                            to={
                                              "/je-update/" + journalEntry._id
                                            }
                                            className='btn btn-sm btn-warning'
                                          // onClick={e =>
                                          //   handleUpdate(journalEntry._id)
                                          // }
                                          >
                                            <FaRegEdit />
                                          </Link>
                                          &nbsp;
                                          <button
                                            className='btn btn-sm btn-danger'
                                            onClick={(e) =>
                                              handleDelete(journalEntry._id)
                                            }
                                          >
                                            <FaRegTrashAlt />
                                          </button>
                                        </td>
                                      </tr>

                                      <tr
                                        className='bg-light'
                                        id={"toggle" + journalEntry._id}
                                        hidden
                                      >
                                        <td colspan='12'>
                                          <div>
                                            <div class='row'>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  No
                                                </label>
                                              </div>
                                              <div class='col-md-3'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Account
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Type
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Date
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: "15px" }}
                                                  class='text-dark'
                                                >
                                                  Amount
                                                </label>
                                              </div>
                                            </div>

                                            {relatedLists
                                              ? relatedLists.map(
                                                (reList, i) => (
                                                  <div class='row'>
                                                    <div class='col-md-2'>
                                                      <div
                                                        style={{
                                                          fontSize: "15px",
                                                        }}
                                                      >
                                                        {++i}
                                                      </div>
                                                    </div>
                                                    <div class='col-md-3'>
                                                      <div
                                                        style={{
                                                          fontSize: "15px",
                                                        }}
                                                      >
                                                        {
                                                          reList
                                                            .relatedAccounting
                                                            .name
                                                        }
                                                      </div>
                                                    </div>
                                                    <div class='col-md-2'>
                                                      {reList.type}
                                                    </div>
                                                    <div class='col-md-2'>
                                                      <div
                                                        style={{
                                                          fontSize: "15px",
                                                        }}
                                                      >
                                                        {
                                                          reList.date.split(
                                                            "T"
                                                          )[0]
                                                        }
                                                      </div>
                                                    </div>
                                                    <div class='col-md-2'>
                                                      <div
                                                        style={{
                                                          fontSize: "15px",
                                                        }}
                                                      >
                                                        {reList.amount}
                                                      </div>
                                                    </div>
                                                  </div>
                                                )
                                              )
                                              : ""}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  ))}
                              {/* {showOri &&
                                journalEntryLists
                                  .slice(0)
                                  .reverse()
                                  .map((journalEntry, i) => (
                                    <tbody className=''>
                                      <tr>
                                        <td>{++i}</td>
                                        <td>
                                          {journalEntry.date
                                            ? journalEntry.date.split('T')[0]
                                            : ''}
                                        </td>
                                        <td>
                                          {journalEntry.relatedAccounting
                                            ? journalEntry.relatedAccounting
                                                .name
                                            : ''}
                                        </td>
                                        <td>{journalEntry.type}</td>
                                        <td>
                                          {journalEntry.relatedBranch
                                            ? journalEntry.relatedBranch
                                            : 'HO'}
                                        </td>

                                        <td>{journalEntry.amount}</td>

                                        <td>{journalEntry.remark}</td>

                                        <td className='text-center'>
                                          <Link
                                            to={
                                              '/je-update/' + journalEntry._id
                                            }
                                            className='btn btn-sm btn-warning'
                                            // onClick={e =>
                                            //   handleUpdate(journalEntry._id)
                                            // }
                                          >
                                            <FaRegEdit />
                                          </Link>
                                          &nbsp;
                                          <button
                                            className='btn btn-sm btn-danger'
                                            onClick={e =>
                                              handleDelete(journalEntry._id)
                                            }
                                          >
                                            <FaRegTrashAlt />
                                          </button>
                                        </td>
                                      </tr>

                                      <tr
                                        className='bg-light'
                                        id={'toggle' + journalEntry._id}
                                        hidden
                                      >
                                        <td colspan='12'>
                                          <div>
                                            <div class='row'>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: '15px' }}
                                                  class='text-dark'
                                                >
                                                  No
                                                </label>
                                              </div>
                                              <div class='col-md-3'>
                                                <label
                                                  style={{ fontSize: '15px' }}
                                                  class='text-dark'
                                                >
                                                  Account
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: '15px' }}
                                                  class='text-dark'
                                                >
                                                  Type
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: '15px' }}
                                                  class='text-dark'
                                                >
                                                  Date
                                                </label>
                                              </div>
                                              <div class='col-md-2'>
                                                <label
                                                  style={{ fontSize: '15px' }}
                                                  class='text-dark'
                                                >
                                                  Amount
                                                </label>
                                              </div>
                                            </div>

                                            {relatedLists
                                              ? relatedLists.map(
                                                  (reList, i) => (
                                                    <div class='row'>
                                                      <div class='col-md-2'>
                                                        <div
                                                          style={{
                                                            fontSize: '15px'
                                                          }}
                                                        >
                                                          {++i}
                                                        </div>
                                                      </div>
                                                      <div class='col-md-3'>
                                                        <div
                                                          style={{
                                                            fontSize: '15px'
                                                          }}
                                                        >
                                                          {
                                                            reList
                                                              .relatedAccounting
                                                              .name
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class='col-md-2'>
                                                        {reList.type}
                                                      </div>
                                                      <div class='col-md-2'>
                                                        <div
                                                          style={{
                                                            fontSize: '15px'
                                                          }}
                                                        >
                                                          {
                                                            reList.date.split(
                                                              'T'
                                                            )[0]
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class='col-md-2'>
                                                        <div
                                                          style={{
                                                            fontSize: '15px'
                                                          }}
                                                        >
                                                          {reList.amount}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                                )
                                              : ''}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  ))} */}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <JEDialog
                open={open}
                close={() => setOpen(false)}
                setJournalEntryLists={setJournalEntryLists}
                journalEntryLists={journalEntryLists}
              />
            </div>
          </section>
        </div>
      </div>
      {/* <!-- /.content-wrapper --> */}
      <footer className='main-footer'>
        <strong>
          Copyright &copy; 2017-2020{" "}
          <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside className='control-sidebar control-sidebar-dark'>
        {/* <!-- Control sidebar content goes here --> */}
      </aside>

      {/* <!-- ./wrapper --> */}
    </div>
  );
};

export default Income;
